import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "badge badge-light-info"
}
const _hoisted_2 = {
  key: 1,
  class: "badge badge-light-success"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.fromSmart)
    ? (_openBlock(), _createBlock("span", _hoisted_1, _toDisplayString(_ctx.$t('message.WMS')), 1))
    : (_openBlock(), _createBlock("span", _hoisted_2, _toDisplayString(_ctx.$t('message.SHOP')), 1))
}